import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import { useTranslation } from 'react-i18next';
import { getCoinAmount } from '../../helpers/Utils'
import { checkUser } from '../../redux/actions';
import axios from 'axios';
import AOS from "aos";
import toast from 'react-hot-toast';
import "aos/dist/aos.css";

import { ServerPath } from '../../shared/constants';

const Withdrawal = ( {currentUser, assets, checkUserAction}) => {
  
  const defaultFee = 0.00;
  const { t } = useTranslation();
  
  const [isLoaded, setIsLoaded] = useState(false);
  const [mdticoin, setMDTI] = useState('');
  const [total_amount, setTotalAmount] = useState(0);
  const [address, setAddress] = useState('');
  const [amount, setAmount] = useState('');
  const [krw_rate, setKrwRate] = useState(1300);
  const [mdti_rate, setMDTIRate] = useState(0);

  const onInit = useCallback(async () => {
    const token = localStorage.getItem('userToken');
    if (!token) return;
  
    try {
      const krw_rate_result = await axios.get('https://api.bithumb.com/public/ticker/ALL');
      const newKrwRate = krw_rate_result.data.data['USDT'].opening_price;
      setKrwRate(newKrwRate);
    } catch (err) {
      console.error('KRW 환율 데이터를 가져오는 중 오류 발생:', err);
    }

    try {
      const mdti_rate_result = await axios.get('https://api.vindax.com/api/v1/returnTicker?symbol=MDTIUSDT');
      setMDTIRate(Number(mdti_rate_result.data.MDTI_USDT.last));
      setIsLoaded(true);
    } catch (err) {
      console.log(err);
    }
    
  }, []); 
  
  useEffect(() => {
    AOS.init();  // AOS 초기화
    onInit();
  
    if (assets) {
      const MDTICoin = assets.find(n => n.token_type === 'MDTI');
      if (MDTICoin) setMDTI(prevMDTI => prevMDTI !== MDTICoin ? MDTICoin : prevMDTI);
    }
  }, [assets]);  // onInit을 의존성 배열에 추가
      
    const handleRequest = () =>{
        
      const token = localStorage.getItem('userToken');
        
        if (currentUser.admin_level === 1)
        {
          toast.error(t('withdrawal.youarebusiness'));
          return;
        }
        if (address ==='' || amount ==='' || Number(amount) ===0)  {
          toast.error(t('withdrawal.needmoreinfo'))
          return;
        }
  
        if (Object.keys(mdticoin).length === 0) {
          toast.error(t('withdrawal.needmorecoin'));
          return;
        }
  
        if (Number(amount) > Number(mdticoin.available_amount)) {
          toast.error(t('withdrawal.nomorecoin'));
          return;
        }
        const senddata ={ user_id : currentUser.id , email:currentUser.email, token_type : "MDTI", amount : Number(amount) - defaultFee, fee: defaultFee, send : '', receive : address, action :'create'}
        axios
          .post(ServerPath+ '/user/withdrawreq' , senddata, { headers: { Authorization: `Bearer ${token}` } } )
          .then((data) => {
            if (data.data.status) {
              toast.success(t('withdrawal.success'));
              checkUserAction();
            } 
            else {
              toast.error(data.data.reason);
            }
          })
          .catch((err) => {
            console.log(err);
          });
        }

  const changeAmount = (value) => {
    setAmount(value);
    setTotalAmount(Number(value) - defaultFee);
  }
  
  return !isLoaded ? (
    <Spinner />
  ) : (
    <section>
      <div className="taps">
		      <div className="tap_bt tapon">SEND</div>
	    </div>
      <div className="snd_step1">
		<div className="snd_con" data-aos="fade-up">
          <div className="snd_title">
            <b>Available balance</b>
            <span><b> {getCoinAmount(mdticoin.available_amount, 2, 'essence')}.<i>{getCoinAmount(mdticoin.available_amount, 2, 'decimal')} MDTI</i></b><img src="images/icon_arr_r.svg" alt="" /></span>
          </div>			
        </div>
        <div className="snd_con" data-aos="fade-up">
          <div className="snd_title">
            <b>Receiving address</b>				
          </div>
          <div className="snd_ip">
            <input type="text" placeholder="Please enter" className="ipty1" 
            value={address}
            onChange={e => setAddress(e.target.value)}
            />
            <div className="qrimg"><img src="images/icon_qr.svg" alt="" /></div>
          </div>
        </div>
        <div className="snd_con" data-aos="fade-up">
          <div className="snd_title">
            <b>Amount</b>				
          </div>
          <div className="snd_ip">
            <input type="text" placeholder="Please enter" className="ipty1" 
              value={amount}
              onChange={e => changeAmount(e.target.value)}
            />
            <div className="qrimg">All</div>
          </div>
          <div className="snd_txt">≈ {Object.keys(mdticoin).length === 0 || krw_rate === 0 || mdti_rate ===0 || mdticoin.total_amount === 0 || isNaN(mdticoin.total_amount * mdti_rate * krw_rate) ?"0":Math.floor(Number(total_amount * mdti_rate * krw_rate)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} KRW</div>
        </div>
      </div>
      <div className="snd_step2">
        <div className="snd_con" data-aos="fade-up">
          <div className="snd_title">
            <b>Fees</b>
            <b>{defaultFee}  MDTI</b>
          </div>			
        </div>
        <div className="snd_con" data-aos="fade-up">
          <div className="snd_title">
            <b>Total amount</b>
            <b>{ getCoinAmount(total_amount, 2)} MDTI</b>
          </div>			
        </div>
        <div className="snd_notice" data-aos="fade-up">
          <img src="images/icon_notice.svg" alt="" />
          <p>NOTICE</p>
          <span>
            Daily Max Limit : 300,000.000.0000 MDTI<br />
            Today's Remaining Transfer Limit : 300,000.000.0000 MDTI<br />
            Extemal withdrawal minimum : 1.0000 MDTI				
          </span>
        </div>
        <button type="button" className="btty2" data-aos="fade-up" onClick={handleRequest}>SEND</button>
      </div>
      
    </section>
    
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser, loading, assets } = authUser;
  return {currentUser, loading, assets}
};
const mapActionToProps = {
  checkUserAction: checkUser,
};

export default connect(mapStateToProps, mapActionToProps)(Withdrawal);

